<template>
	<div class="nzxt-header">
		<template v-if="$route.name != 'step4-mobile'">
			<div id="start-over-bld" class="modal fade in">
				<div class="modal-dialog modal-sm" role="document">
					<div class="modal-content text-center">
						<div class="modal-header text-center">
							<button
								type="button"
								class="close"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">×</span>
							</button>
							<h2 class="text-white">START OVER</h2>
						</div>
						<div class="modal-body text-white">
							<p class="load-last-build">LOAD FROM YOUR LAST BUILD?</p>
							<div class="text-center last-build-link">
								<a :href="currentDomain + draftUrl" target="_self" class="text-orchid">{{ currentDomain + draftUrl }}</a>
							</div>
							<div class="text-center">
								<button type="button" class="btn btn-green btn-outline btn-block" @click="startOverBld()">START OVER</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div id="get-started-bld" class="modal fade in">
				<div class="modal-dialog modal-sm" role="document">
					<div class="modal-content text-center">
						<div class="modal-header text-center">
							<button
								type="button"
								class="close"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">×</span>
							</button>
							<h2 class="text-white">START OVER</h2>
						</div>
						<div class="modal-body text-white">
							<p class="your-cart-empty">
								Your cart is currently empty. Would you like to start a new build?
							</p>
							<div class="text-center">
								<a
									href="#"
									type="button"
									class="btn btn-green btn-outline btn-block"
									@click.prevent="goToStep1({ Which: 'Empty Cart Modal' })"
								>
									GET STARTED
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				id="leave-configurator-warning"
				class="modal fade in"
				tabindex="-1"
				role="dialog"
			>
				<div class="modal-dialog modal-sm" role="document">
					<div class="modal-content">
						<div class="modal-header text-center">
							<button
								type="button"
								class="close"
								data-dismiss="modal"
								aria-label="Close"
							>
								<span aria-hidden="true">×</span>
							</button>
							<h2 class="text-white">Leaving Configurator</h2>
						</div>
						<div class="modal-body text-white">
							<p>Going back now will reset the configurator. Select 'save' or 'share' to continue with your selections later.</p>
							<div class="text-center">
								<button class="big-submit" @click="startOverBld()">Proceed</button>
								<button id="leave-save" class="big-submit">Save</button>
								<button data-dismiss="modal" class="big-submit">Cancel</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- header-nav - use when needed -:class="{'with-promo-bar': showPromoBar}"-->
			<div class="row visible-lg">
				<!-- nav-bar grey-->
				<nav id="navbar-spy" class="navbar navbar-default bg-green m-b-0" data-navbar>
					<!-- min-head -->
					<div class="collapse navbar-collapse log-collapse bg-white p-x-0 pos-r ">
						<div class="container-fluid responsive-navbar-padding">
							<ul class="nav navbar-header navbar-nav navbar-left">
								<li class="main-logo">
									<a class="btn-logo" href="https://www.nzxt.com/" target="_blank">
										<img src="/images/logos/logo-nzxt-black.png" alt="BLD">
									</a>
								</li>
							</ul>
							<ul v-if="!POS_MODE" class="nav navbar-nav navbar-right">
								<li>
									<template v-if="user.username">
										<router-link class="user-name user-menu" to="/user/account">
											<img @error="setDefaultAvatar('.avatar')" :src="user.photo || '/images/users/avatar.png'" class="avatar user-avatar">Welcome, {{ user.username }}
										</router-link>
										<div class="user-menu-view bg-black">
											<div class="container">
												<ul class="inline p-x-0 m-b-0 text-white">
													<li>
														<router-link :to="{ name: 'UserAccount', query: { currentTab: 'account-info'}}">
															Account Information
														</router-link>
													</li>
													<li>
														<router-link :to="{ name: 'UserAccount', query: { currentTab: 'saved-build'}}">
															Saved Builds
														</router-link>
													</li>
													<li>
														<router-link :to="{ name: 'UserAccount', query: { currentTab: 'order-history'}}">
															Order History
														</router-link>
													</li>
													<li>
														<router-link :to="{ name: 'UserAccount', query: { currentTab: 'tickets'}}">
															Tickets
														</router-link>
													</li>
													<li>
														<router-link :to="{ name: 'UserAccount', query: { currentTab: 'create-tickets'}}">
															Create a Ticket
														</router-link>
													</li>
												</ul>
											</div>
										</div>
									</template>
									<template v-else>
										<a class="pointer" @click="openSignInModal()">Sign in</a>
									</template>
								</li>
								<li>
									<template v-if="user.username">
										<a class="pointer" @click="logout()">Log Out</a>
									</template>
									<template v-else>
										<!-- We're using a method to open the modal because there is a weird side effect
										when we use the data attributes
										-->
										<a class="pointer" @click="openModal">Sign up</a>
									</template>
								</li>
								<header-region-picker />
							</ul>
						</div>
					</div>
					<!-- /.min-head -->
					<div class="container-fluid responsive-navbar-padding">
						<!-- Brand and toggle get grouped for better mobile display -->
						<div class="navbar-header">
							<button
								type="button"
								class="navbar-toggle collapsed"
								data-toggle="collapse"
								data-target="#collapse-bar, #log-collapse"
								aria-expanded="false"
							>
								<span class="sr-only">Toggle navigation</span>
								<span class="icon-bar"/>
								<span class="icon-bar"/>
								<span class="icon-bar"/>
							</button>
							<div class="main-logo clearfix">
								<router-link class="dropdown-item" to="/">
									<img src="/images/logos/logo-bld.png" alt="BLD">
								</router-link>
							</div>
						</div>

						<!-- Collect the nav links, forms, and other content for toggling -->
						<div id="collapse-bar" class="collapse navbar-collapse">
							<ul class="nav navbar-nav navbar-left">
								<li>
									<router-link to="/what-is-bld">What is BLD</router-link>
								</li>
								<li>
									<a :href="getPathByRouteName('starter-series')" @click.prevent="goToStarterLine()">{{ CONSTANTS.STARTERPCSERIES.TITLE }}</a>
								</li>
								<li>
									<a :href="getPathByRouteName('streaming-pc')" @click.prevent="goToStreamerPc()">{{ CONSTANTS.STREAMERPC.TITLE }}</a>
								</li>
								<li>
									<a :href="getPathByRouteName('h1-mini-pc')" @click.prevent="goToH1MiniPc()">{{ CONSTANTS.H1MINIPC.TITLE }}</a>
								</li>
								<li>
									<a :href="getPathByRouteName('creator-pc')" @click.prevent="goToCreatorPC()">{{ CONSTANTS.CREATORPC.TITLE }}</a>
								</li>
								<li>
									<router-link to="/reviews" @click.native="trackCustomerReviews()">Customer Reviews</router-link>
								</li>
								<li v-if="!POS_MODE">
									<a target="_blank" href="https://www.nzxt.com/customer-support" @click.prevent="trackSupportViews($event)">
										Support
									</a>
								</li>
								<li v-if="!userDraftId && !$route.meta.starterPC && !POS_MODE" class="get-started-button">
									<a :href="getPathByRouteName('step1')" class="btn btn-white btn-outline" @click.prevent="goToStep1({Which: 'Menu'})">GET STARTED</a>
								</li>
								<li v-if="$route.meta.starterPC" class="get-started-button">
									<a
										@click.prevent="onBuildYourOwn()"
										href="#"
										active-class=""
										class="btn btn-white btn-outline"
									>
										Build Your Own
									</a>
								</li>
							</ul>
							<ul v-if="!$route.meta.starterPC && !POS_MODE" class="nav navbar-nav navbar-right">
								<template v-if="userDraftId">
									<li class="start-over-button">
										<a class="btn btn-outline" @click="startBuilding()">START OVER</a>
									</li>
									<li>
										<a class="go-to-checkout purchase pointer" @click="goBackToCheckout()">
											<img src="/images/icons/overview-active.png" alt="">(1)
										</a>
									</li>
								</template>
							</ul>
						</div>
						<!-- /.navbar-collapse -->
					</div>
					<!-- /.container-fluid -->
				</nav>
				<!-- /.nav-bar grey-->
			</div>
			<!-- /.header-nav -->
			<!-- header-medium :class="{'with-promo-bar': showPromoBar}" -->
			<div class="visible-md visible-sm">
				<div class="row header-dp" data-navbar>
					<div v-show="showMenuBars()" class="container log-collapse">
						<ul class="nav navbar-header navbar-nav navbar-left">
							<li class="main-logo ">
								<a class="btn-logo" href="https://www.nzxt.com/" target="_blank">
									<img src="/images/logos/logo-nzxt-black.png" alt="BLD">
								</a>
							</li>
						</ul>
						<ul v-if="!POS_MODE" class="nav navbar-nav navbar-right">
							<li>
								<template v-if="user.username">
									<router-link class="user-name user-menu" to="/user/account">
										<img @error="setDefaultAvatar('.avatar')" :src="user.photo || '/images/users/avatar.png'" class="avatar">Welcome, {{ user.username }}
									</router-link>
									<div class="user-menu-view bg-black">
										<div class="container">
											<ul class="inline p-x-0 m-b-0 text-white">
												<li>
													<router-link :to="{ name: 'UserAccount', params: { currentTab: 'account-info'}}">
														Account Information
													</router-link>
												</li>
												<li>
													<router-link :to="{ name: 'UserAccount', params: { currentTab: 'saved-build'}}">
														Saved Builds
													</router-link>
												</li>
												<li>
													<router-link :to="{ name: 'UserAccount', params: { currentTab: 'order-history'}}">
														Order History
													</router-link>
												</li>
												<li>
													<router-link :to="{ name: 'UserAccount', params: { currentTab: 'tickets'}}">
														Tickets
													</router-link>
												</li>
												<li>
													<router-link :to="{ name: 'UserAccount', params: { currentTab: 'create-tickets'}}">
														Create a Ticket
													</router-link>
												</li>
											</ul>
										</div>
									</div>
								</template>
								<template v-else>
									<a class="pointer" @click="openSignInModal()">Log in</a>
								</template>
							</li>
							<li>
								<template v-if="user.username">
									<a class="pointer" @click="logout()">Log Out</a>
								</template>
								<template v-else>
									<!-- We're using a method to open the modal because there is a weird side effect
								when we use the data attributes
								-->
									<a class="pointer" @click="openModal">Sign up</a>
								</template>
							</li>
							<header-region-picker />
						</ul>
					</div>
					<!-- nav-bar grey-->
					<nav id="navbar-spy-m" class="navbar navbar-default bg-green m-b-0">
						<!-- min-head -->
						<div class="container">
							<!-- Brand and toggle get grouped for better mobile display -->
							<div class="navbar-header">
								<div class="main-logo clearfix">
									<router-link class="dropdown-item" to="/">
										<img src="/images/logos/logo-bld.png" alt="BLD">
									</router-link>
								</div>
							</div>
							<!-- Collect the nav links, forms, and other content for toggling -->
							<div class="dropdown">
								<button
									id="header-menu-dp"
									class="btn btn-green dropdown-toggle"
									type="button"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<i class="fa fa-bars"/>
								</button>
								<div class="dropdown-menu bg-green text-white" aria-labelledby="header-menu-dp">
									<router-link to="/what-is-bld">What is BLD</router-link>
									<a :href="getPathByRouteName('starter-series')" @click.prevent="goToStarterLine()">{{ CONSTANTS.STARTERPCSERIES.TITLE }}</a>
									<a :href="getPathByRouteName('streaming-pc')" @click.prevent="goToStreamerPc()">{{ CONSTANTS.STREAMERPC.TITLE }}</a>
									<a :href="getPathByRouteName('h1-mini-pc')" @click.prevent="goToH1MiniPc()">{{ CONSTANTS.H1MINIPC.TITLE }}</a>
									<a :href="getPathByRouteName('creator-pc')" @click.prevent="goToCreatorPC()">{{ CONSTANTS.CREATORPC.TITLE }}</a>
									<router-link to="/reviews" @click.native="trackCustomerReviews()">Customer Reviews</router-link>
									<a
										v-if="!POS_MODE"
										target="_blank"
										href="https://www.nzxt.com/customer-support"
										@click.prevent="trackSupportViews($event)"
									>
										Support
									</a>
									<a
										v-if="!$route.meta.starterPC && !POS_MODE"
										href="#"
										class="btn btn-white btn-outline"
										@click.prevent="goToStep1({Which: 'Menu'})"
									>
										GET STARTED
									</a>
									<a
										v-else
										@click.prevent="onBuildYourOwn()"
										href="#"
										active-class=""
										class="btn btn-white btn-outline"
									>
										Build Your Own
									</a>
								</div>
							</div>
							<!-- /.navbar-collapse -->
						</div>
						<!-- /.container-fluid -->
					</nav>
					<!-- /.nav-bar grey-->
				</div>
			</div>
			<!-- /header-medium -->
			<!-- header-small :class="{'with-promo-bar': showPromoBar}" -->
			<div v-show="$route.name != 'step4-mobile'" class="visible-xs">
				<div class="row header-dp" data-navbar>
					<!-- min-head -->
					<div v-show="showMenuBars()" class="navbar-collapse log-collapse bg-white p-x-0 pos-r">
						<div class="container-fluid p-l-md">
							<ul class="nav navbar-header navbar-nav navbar-left">
								<li class="main-logo ">
									<a class="btn-logo" href="https://www.nzxt.com/" target="_blank">
										<img src="/images/logos/logo-nzxt-black.png" alt="BLD">
									</a>
								</li>
							</ul>
						</div>
					</div>
					<!-- /.min-head -->
					<!-- nav-bar grey-->
					<nav
						v-show="$route.name != 'step4-mobile'"
						id="navbar-spy-s"
						class="navbar navbar-default bg-green m-b-0"
					>
						<!-- min-head -->
						<div class="container p-l-md">
							<!-- Brand and toggle get grouped for better mobile display -->
							<div class="navbar-header pull-left">
								<div class="main-logo clearfix">
									<router-link class="dropdown-item" to="/">
										<img src="/images/logos/logo-bld.png" alt="BLD">
									</router-link>
								</div>
							</div>
							<!-- Collect the nav links, forms, and other content for toggling -->
							<div class="dropdown" ref="mobile-dropdown">
								<button
									id="header-menu-dp"
									class="btn btn-green dropdown-toggle"
									type="button"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<i class="fa fa-bars"/>
								</button>
								<div
									:style="keepMobileDropdownOpen ? 'display: block' : ''"
									class="dropdown-menu bg-green text-white"
									aria-labelledby="header-menu-dp"
								>
									<router-link to="/what-is-bld">What is BLD</router-link>
									<a :href="getPathByRouteName('starter-series')" @click.prevent="goToStarterLine()">{{ CONSTANTS.STARTERPCSERIES.TITLE }}</a>
									<a :href="getPathByRouteName('streaming-pc')" @click.prevent="goToStreamerPc()">{{ CONSTANTS.STREAMERPC.TITLE }}</a>
									<a :href="getPathByRouteName('h1-mini-pc')" @click.prevent="goToH1MiniPc()">{{ CONSTANTS.H1MINIPC.TITLE }}</a>
									<a :href="getPathByRouteName('creator-pc')" @click.prevent="goToCreatorPC()">{{ CONSTANTS.CREATORPC.TITLE }}</a>
									<router-link to="/reviews" @click.native="trackCustomerReviews()">Customer Reviews</router-link>
									<a
										v-if="!POS_MODE"
										target="_blank"
										href="https://www.nzxt.com/customer-support"
										@click.prevent="trackSupportViews($event)"
									>
										Support
									</a>
									<div v-if="!POS_MODE" class="log-sign">
										<ul class="list-none">
											<li>
												<template v-if="user.username">
													<router-link class="user-name user-menu" to="/user/account">
														<img @error="setDefaultAvatar('.avatar')" :src="user.photo || '/images/users/avatar.png'" class="avatar">Welcome, {{ user.username }}
													</router-link>
													<div class="user-menu-view bg-black">
														<div class="container">
															<ul class="inline p-x-0 m-b-0 text-white">
																<li>
																	<router-link :to="{ name: 'UserAccount', params: { currentTab: 'account-info'}}">
																		Account Information
																	</router-link>
																</li>
																<li>
																	<router-link :to="{ name: 'UserAccount', params: { currentTab: 'saved-build'}}">
																		Saved Builds
																	</router-link>
																</li>
																<li>
																	<router-link :to="{ name: 'UserAccount', params: { currentTab: 'order-history'}}">
																		Order History
																	</router-link>
																</li>
																<li>
																	<router-link :to="{ name: 'UserAccount', params: { currentTab: 'tickets'}}">
																		Tickets
																	</router-link>
																</li>
																<li>
																	<router-link :to="{ name: 'UserAccount', params: { currentTab: 'create-tickets'}}">
																		Create a Ticket
																	</router-link>
																</li>
															</ul>
														</div>
													</div>
												</template>
												<template v-else>
													<a @click="openSignInModal()">Log in</a>
												</template>
											</li>
											<li>
												<template v-if="user.username">
													<a @click="logout()">Log Out</a>
												</template>
												<template v-else>
													<!-- We're using a method to open the modal because there is a weird side effect
													when we use the data attributes -->
													<a @click="openModal()">Sign up</a>
												</template>
											</li>
										</ul>
									</div>
									<header-region-picker
										is-mobile
										@clicked="keepMobileDropdownOpen = true"
										@blured="onRegionPickerBlured"
									/>
									<a
										v-if="!$route.meta.starterPC && !POS_MODE"
										href="#"
										class="btn btn-white btn-outline btn-get-started"
										@click.prevent="goToStep1({Which: 'Menu'})"
									>GET STARTED</a>
									<a
										v-else
										@click.prevent="onBuildYourOwn()"
										href="#"
										active-class=""
										class="btn btn-white btn-outline btn-get-started"
									>
										Build Your Own
									</a>
								</div>
							</div>
							<!-- /.navbar-collapse -->
						</div>
						<!-- /.container-fluid -->
					</nav>
					<!-- /.nav-bar grey-->
				</div>
			</div>
			<!-- /header-small -->
			<promos-bars v-if="!POS_MODE" />
			<promo-sale-flash-banner />
		</template>

		<!-- modals -->

		<!-- login-modal -->
		<login-modal v-if="!POS_MODE" />
		<!-- /.login-modal -->

		<!-- sign-up-modal -->
		<sign-up-modal v-if="!POS_MODE" />
		<!-- /.sign-up-modal -->

		<!-- /.modals -->
	</div>
</template>

<script>
import SignUpModal from "./components/user/sign-up-modal.vue";
import LoginModal from "./components/user/login-modal.vue";
import { clearUserData, isMobile, getUserData } from "@u/helpers";
import { mapActions, mapGetters, mapState } from "vuex";
import { configuratorMixins, heapAnalytics, helpers, userMixin } from "@u/mixins";
import promosBars from "./components/store/promos-bars";
import CONSTANTS from "./config/constants";
import HeaderRegionPicker from "./header-region-picker";
import { gtmTrack, gtmUntrack } from "@/util/gtm";
import PromoSaleFlashBanner from "@/components/store/flash-banners/promo-sale-flash-banner";

export default {
	name: "Header",
	components: {
		promosBars,
		LoginModal,
		SignUpModal,
		HeaderRegionPicker,
		PromoSaleFlashBanner
	},
	mixins: [
		configuratorMixins,
		heapAnalytics,
		helpers,
		userMixin
	],
	data() {
		return {
			avatar: "",
			CONSTANTS,
			currentDomain: window.location.origin,
			draftUrl: false,
			user: getUserData() || {},
			keepMobileDropdownOpen: false
		};
	},
	computed: {
		...mapState({
			userDraftId: state => state.User.draftId,
			userData: state => state.User.data
		}),
		...mapGetters({
			draftId: "draftId",
			trackStarterType: "StarterPc/getTrackType"
		}),
		showPromoBar() {
			return !this.$route.path.startsWith("/BLD") && !sessionStorage.getItem("dismissPromo");
		}
	},
	watch: {
		userData(data) {
			this.user = _.cloneDeep(data);
		}
	},
	created() {
		this.getDraftUrl();
		if (window.localStorage.getItem("session-draft")) {
			this.$store.dispatch("changeUserDraftId", window.localStorage.getItem("session-draft"));
		}
	},
	mounted() {
		if (!Cookies.get("cookies_id")) {
			clearUserData();
		}

		if (sessionStorage.getItem("session_expired")) {
			sessionStorage.clear("session_expired");
			toastr && toastr.warning("The session has expired, please sign in again", "Warning", {
				timeOut: 10000
			});
		}

		EventBus.$on("user-logged-in", (user) => {
			this.user = user;
		});

		this.watchMobileDropdown();
	},
	methods: {
		...mapActions(["changeActiveTab"]),
		openSignInModal() {
			this.$modal.show("login-modal");
		},
		openModal() {
			this.$modal.show("sign-up-modal");
		},
		getPathByRouteName(routeName) {
			return this.$router.options.routes.find(route => route.name == routeName).path;
		},
		goToStarterLine() {
			this.trackAll("Client: Click SP Tab");
			this.$router.push({ name: "starter-series" });
		},
		goToStreamerPc() {
			this.trackAll("Client: Streamer PC Tab");
			this.$router.push({ name: "streaming-pc" });
		},
		goToH1MiniPc() {
			this.trackAll("Client: H1 MINI PC Tab");
			this.$router.push({ name: "h1-mini-pc" });
		},
		goToCreatorPC() {
			this.trackAll("Client: Creator PC Tab");
			this.$router.push({ name: "creator-pc" });
		},
		goToStep1(eventProperties) {
			this.trackAll("Client: Click Get Started", eventProperties);
			this.$router.push({
				name: "step1"
			});
		},
		async logout() {
			await axios({
				url: "/auth/logout",
				method: "POST"
			}).then(() => {
				this.user = {};
				clearUserData();
				gtmUntrack.userSession();
				gtmUntrack.sessionVariables();
				this.$emit("logout");

				if (window.location.pathname.includes("/user")) {
					this.$router.push("/");
				}
			});
		},
		getDraftUrl() {
			let draftBuild = false;

			if (window.localStorage.getItem("session-draft") && window.localStorage.getItem("session-price")) {
				draftBuild = `/bld/step4?price=${window.localStorage.getItem("session-price")}&draft=${window.localStorage.getItem("session-draft")}`;
				this.draftUrl = draftBuild;
			}

			return draftBuild;
		},
		startBuilding() {
			this.getDraftUrl();

			if (!this.$route.hash.includes("draft") && this.$route.path != "/bld/step4") {
				$("#start-over-bld").modal("show");
			} else if (this.$route.path == "/bld/step4") {
				$("#leave-warning-step-1").modal("show");
			} else {
				$("#leave-configurator-warning").modal("show");
			}
		},
		startOverBld() {
			$("#start-over-bld").modal("hide");
			this.changeActiveTab("case");
			this.restartBuild();
			this.$router.push({
				name: "step1"
			});
		},
		goBackToCheckout() {
			if (this.$route.name != "step5") {
				if (!window.localStorage.getItem("session-draft")) {
					$("#get-started-bld").modal("show");
				} else {
					this.$router.push({
						name: "step5",
						query: {
							price: window.localStorage.getItem("session-price"),
							draft: window.localStorage.getItem("session-draft")
						}
					});
				}
			}
		},
		onBuildYourOwn() {
			const routeSuffix = this.$route.name.match(/-[a-z]+$/i)[0];
			const pages = {
				"-pc": "Product",
				"-accessories": "Accessory",
				"-cart": "Cart"
			};

			this.trackAll(`Client: Click ${this.trackStarterType} BuildYourOwn`, {
				page: `${pages[routeSuffix]} page`
			});
			this.$router.push({ name: "step1" });
		},
		showMenuBars() {
			if (["step1", "step2", "step3", "step5"].includes(this.$route.name)) {
				return false;
			}

			return true;
		},
		isMobile() {
			return isMobile();
		},
		watchMobileDropdown() {
			document.addEventListener("click", (e) => {
				const isRegionPicker = e.target.className.includes("region-picker") && isMobile();
				this.keepMobileDropdownOpen = isRegionPicker;
			});
		},
		onRegionPickerBlured() {
			this.keepMobileDropdownOpen = false;
		},
		trackSupportViews() {
			const url = event.target.href;
			gtmTrack.visitSupportPage();
			if (url) {
				window.open(url);
			}
		},
		trackCustomerReviews() {
			gtmTrack.customReviewsClick();
		}
	}
};
</script>

<style lang="scss">
@import '~@s/_asset-mixers.scss';

.nzxt-header {
	overflow-x: hidden;
}

.avatar {
	float: left;
	margin-right: 10px;
	opacity: 1;
	height: 30px;
	border: 1px solid $purple;
}

#start-over-bld .load-last-build,
#get-started-bld .your-cart-empty {
	margin: 20px 0;
	color: gray;
}

.last-build-link {
	padding: 15px;
	padding-top: 0;
	padding-bottom: 30px;
}

.get-started-button {
	position: absolute !important;
	right: 0;
	top: 7px;
}

.start-over-button a {
	margin: 0 !important;
	border-color: white;
	padding: 10px 15px !important;
}

.start-over-button a:hover {
	background-color: white !important;
	color: $purple !important;
}

.navbar-nav {
	li {
		a {
			margin-right: 0 !important;

			@media (min-width: 1200px) and (max-width: 1315px) {
				padding-left: 10px !important;
				padding-right: 10px !important;
			}
		}

		a:hover, a:focus, .router-link-active {
			color: $orchid !important;
		}
	}
}

.responsive-navbar-padding {
	@media (min-width: 1500px) {
		padding: 0 60px;
	}

	padding: 0 30px;
}

.log-sign {
	li a {
		cursor: pointer;
	}
}

</style>
